import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { useNotes } from "../contexts/NotesContext";

export const TabSwitcher = () => {

	const { activeTab, switchTab } = useNotes();

	return (
		<RadioGroup value={activeTab} onValueChange={switchTab} className="grid grid-flow-col auto-cols-fr max-w-max gap-[5px] bg-theme-2 p-[3px] rounded-lg mb-4">
			<div className="flex items-center space-x-2">
				<RadioGroupItem value="notes" id="notes" className="peer sr-only" />
				<label
					htmlFor="notes"
					className={`cursor-pointer text-sm font-medium px-[15px] py-[5px] rounded-lg text-center w-full ${activeTab === "notes" ? "bg-theme-0" : "hover:bg-theme-1"}`}
				>
					Notes
				</label>
			</div>
			<div className="flex items-center space-x-2">
				<RadioGroupItem value="transcript" id="transcript" className="peer sr-only" />
				<label
					htmlFor="transcript"
					className={`cursor-pointer text-sm font-medium px-[15px] py-[5px] rounded-lg text-center w-full ${activeTab === "transcript" ? "bg-theme-0" : "hover:bg-theme-1"}`}
				>
					Transcript
				</label>
			</div>
			<div className="flex items-center space-x-2">
				<RadioGroupItem value="ai" id="ai" className="peer sr-only" />
				<label
					htmlFor="ai"
					className={`cursor-pointer text-sm font-medium px-[15px] py-[5px] rounded-lg text-center w-full ${activeTab === "ai" ? "bg-theme-0" : "hover:bg-theme-1"}`}
				>
					SmartNote
				</label>
			</div>
		</RadioGroup>
	)
}